export const Work = [
    {
        id:1,
        name:"Delta Landing  Page",
        description:"Delta landing page design made by using styled components and framer motion for animation.",
        tags:["react","framer-motion","react-router","styledComponents"],
        demo:"https://data-dump-delta.netlify.app/",
    },
    {
        id:2,
        name:"Esignify",
        description:"Design a landing page with styled components and incorporate Framer Motion for captivating animations.",
        tags:["react","framer-motion","styledComponents","react-router"],
        demo:"https://esignify.netlify.app/",    
    },
    {
        id:3,
        name:"Redux-Toolkit E-comm",
        description:"Created a straightforward e-commerce price and quantity listing page using Redux Toolkit.",
        tags:["react","api", "axios", "redux-toolkit"],
        demo:"https://ecom-prototype.netlify.app/",
    },
    {
        id:4,
        name:"Real Estate properties",
        description:"A Real estate website build in ReactJS. With searching and filtering functionalities.",
        tags:["react","tailwind","react-router"],
        demo:"https://eastery-real-estate.netlify.app/", 
    },
    {
        id:6,
        name:"Mercor Dashboard Page",
        description:"A reponsive dashboard design that has drag and drop feature for mercor making use of vite and tailwind as a css library.",
        tags:["react","react-router","figma","css","tailwind","vite","react-beautiful-dnd"],
        demo:" https://kanban-mercor.netlify.app/",    
    },
] 